import { localizedString } from "../components/Activities/ActivitySheet";

type DocData = {
    color: string;
    created_at: string;
    en?: string | null;
    es?: string | null;
    fr?: string | null;
    id: string;
    internal_title?: string;
    it?: string | null;
    levels?: string[];
    pt?: string | null;
    targets?: string | null;
    title: localizedString;
}

type Doc = {
    draft: DocData;
    last_update: number;
    published?: DocData;
}

class Docs {
    private static instance: Docs;

    public data:{ [key: string]: Doc } = {};
    public ts: number = 0;

    public static getInstance(): Docs {
        if (!Docs.instance) {
            Docs.instance = new Docs();
        }

        return Docs.instance;
    }
}

export default Docs;